<template>
  <v-touch @panup="panUp">
    <div class="container">
      <p class="img"></p>
      <p class="text">
        <span class="icon">1</span>打开app
        store，点击底部app按钮，滚动至页面底部，找到并选择“绑定支付宝、微信支付或银联卡”；
      </p>
      <p class="up_icon"></p>
    </div>
  </v-touch>
</template>

<script>
export default {
  created() {
    document.getElementsByTagName("title")[0].innerText = "微信支付教程";
  },
  methods: {
    panUp() {
      this.$router.push("weixin_course_two");
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("../../../assets/css/base.css");
.container {
  width: 100vw;
  height: 100vh;
  text-align: center;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  .img {
    display: inline-block;
    background: url("../../../assets/images/jiaocheng/weixin/wxpay_bg_01@2x.png")
      no-repeat;
    background-size: cover;
    width: 12.25rem;
    height: 19.95rem;
    margin-top: 3.35rem;
  }
  .text {
    margin-top: 0.85rem;
    font-size: 0.6rem;
    font-family: "PingFangSC-Semibold,PingFang SC";
    font-weight: 600;
    color: rgba(87, 86, 90, 1);
    .icon {
      display: inline-block;
      background: url("../../../assets/images/jiaocheng/weixin/num_bg@2x.png")
        no-repeat;
      background-size: cover;
      width: 1.2rem;
      height: 1.2rem;
      line-height: 1.2rem;
      font-size: 0.7rem;
      font-family: "PingFangSC-Semibold,PingFang SC";
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      margin-right: 0.5rem;
    }
  }
  .up_icon {
    display: inline-block;
    background: url("../../../assets/images/jiaocheng/weixin/up@2x.png")
      no-repeat;
    background-size: cover;
    width: 1.2rem;
    height: 1.2rem;
    margin-top: 0.95rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wsm_month_card/pay/one.vue